import { Bell, Plane, MapPin, Clock, ChevronRight } from 'lucide-react'

interface IncomingFlightCardProps {
  onContinue: () => void
}

export function IncomingFlightCard({ onContinue }: IncomingFlightCardProps) {
  return (
    <div className="bg-amber-950/60 border border-amber-400/40 rounded-xl p-4 backdrop-blur-sm">
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <div className="w-7 h-7 rounded-full bg-amber-400/20 flex items-center justify-center flex-shrink-0">
          <Bell className="w-3.5 h-3.5 text-amber-300" />
        </div>
        <div>
          <div className="text-xs text-amber-300/70 uppercase tracking-widest font-semibold">
            Inbound Request
          </div>
          <div className="text-sm font-bold text-amber-100">
            Overnight Hangar Storage
          </div>
        </div>
      </div>

      {/* Aircraft details */}
      <div className="bg-black/30 rounded-lg p-3 mb-3 space-y-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Plane className="w-4 h-4 text-amber-300 rotate-45 flex-shrink-0" />
            <div>
              <div className="text-base font-bold text-white font-mono">C-GBLR</div>
              <div className="text-xs text-white/50">Bombardier Global 7500</div>
            </div>
          </div>
          <div className="text-right">
            <div className="text-xs text-white/40">Client</div>
            <div className="text-sm font-semibold text-white">Azure Sky Group</div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 pt-1 border-t border-white/10">
          <div className="flex items-center gap-1.5 text-xs text-white/60">
            <MapPin className="w-3 h-3 text-white/30" />
            <span>From CYYZ</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-white/60">
            <Clock className="w-3 h-3 text-white/30" />
            <span>ETA 18:15</span>
          </div>
        </div>
      </div>

      {/* Dimensions callout */}
      <div className="bg-rose-950/40 border border-rose-500/20 rounded-lg px-3 py-2 mb-3">
        <div className="text-xs text-rose-300/70 font-semibold uppercase tracking-wide mb-1">
          Space Challenge
        </div>
        <div className="text-xs text-white/70 leading-snug">
          Wingspan <span className="text-white font-semibold">104 ft</span> · Length{' '}
          <span className="text-white font-semibold">111 ft</span> · Tail{' '}
          <span className="text-white font-semibold">27 ft</span>
        </div>
        <div className="text-xs text-rose-300 mt-1">
          Hangar appears full — conventional planning would decline.
        </div>
      </div>

      <button
        onClick={onContinue}
        className="w-full flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400
                   text-black font-bold text-sm rounded-lg py-2.5 transition-colors"
      >
        <span>Optimize Hangar Stack</span>
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  )
}
